import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const Fields = ({detail = {}, prefix = '', multiplePanes = true, children}) => {
  return (
    <Panes
      entity={detail}
      prefix={prefix}
      panes={[
        {
          title: 'Core Details',
          fields: [
            <TextField
              name="title"
              prefix={prefix}
              label="Title"
              rules={{required: 'Please enter a title for this detail'}}
            />,
            <TextField
              name="value"
              prefix={prefix}
              label="Value"
              rules={{required: 'Please enter a value for this detail'}}
            />,
          ]
        }, {
          title: '',
          fields: []
        },
      ]}
      title={multiplePanes ? null : 'Details'}
    >{children}</Panes>
  );
};

export default Fields;
